// extracted by mini-css-extract-plugin
export default {"main":"newsForm_main__G41Ah","formImage":"newsForm_formImage__InXhV","formInput":"newsForm_formInput__Zuqh2"};